var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoDepositsPlayersAcc = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Deposits",
    transform: "translate(-26.289 -77.833)",
    fill: "#00a1af"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48490",
    "data-name": "Path 48490",
    d: "M27.452,85.446a1.125,1.125,0,0,0,0,2.249h2.307a7.186,7.186,0,0,1,.8-2.249Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48491",
    "data-name": "Path 48491",
    d: "M35.05,81.4H30.469a1.125,1.125,0,0,0,0,2.249h1.3A7.138,7.138,0,0,1,35.05,81.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48491-2",
    "data-name": "Path 48491",
    d: "M43.194,83.654h0a1.125,1.125,0,0,0,0-2.249H39.222A6.351,6.351,0,0,1,43.194,83.654Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48493",
    "data-name": "Path 48493",
    d: "M27.452,77.833a1.141,1.141,0,0,0,0,2.281H38.723a1.141,1.141,0,0,0,0-2.281Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48494",
    "data-name": "Path 48494",
    d: "M29.667,89.506H27.452a1.125,1.125,0,0,0,0,2.249h2.754A5.144,5.144,0,0,1,29.667,89.506Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48495",
    "data-name": "Path 48495",
    d: "M27.452,95.832h5.594A7.211,7.211,0,0,1,30.9,93.55H27.452a1.142,1.142,0,0,0-.067,2.282Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M44.259,88.507a6.245,6.245,0,0,0-3.472-5A6.551,6.551,0,0,0,32.1,86.2a6.284,6.284,0,0,0-.681,2.307,5.8,5.8,0,0,0-.018.894,6.241,6.241,0,0,0,.7,2.539l.138.242a1.293,1.293,0,0,1,.073.125c.055.089.12.18.175.269.055.072.1.143.157.214l.037.045A6.515,6.515,0,0,0,35.9,95.044l.037.009a2.547,2.547,0,0,0,.249.072l.147.035a1.8,1.8,0,0,0,.2.045c.12.027.23.044.35.063a.636.636,0,0,1,.138.018l.286.026.129.009c.129.009.268.009.407.009s.267,0,.406-.009l.13-.009.276-.026a.644.644,0,0,1,.138-.018c.12-.019.24-.036.35-.063.073-.018.138-.027.211-.045l.148-.035q.126-.03.249-.072l.037-.009a6.5,6.5,0,0,0,3.2-2.209l.037-.045c.045-.071.1-.142.156-.214.055-.089.12-.179.175-.269.027-.044.046-.089.073-.125l.138-.242a6.122,6.122,0,0,0,.712-2.539A5.8,5.8,0,0,0,44.259,88.507Zm-4.77,2.906a2.084,2.084,0,0,1-1.133.483v1.09h-.915V91.913a3.289,3.289,0,0,1-.93-.134c-.2-.063-.4-.133-.59-.215l-.073-.044.277-.823.092.045a5.226,5.226,0,0,0,.617.224,3.474,3.474,0,0,0,.856.089,1.575,1.575,0,0,0,.894-.2.546.546,0,0,0,.23-.446.557.557,0,0,0-.1-.358,1.352,1.352,0,0,0-.286-.269,4.027,4.027,0,0,0-.433-.224c-.175-.071-.359-.134-.524-.187-.139-.054-.277-.107-.407-.161l-.129-.054a2.647,2.647,0,0,1-.479-.295,1.321,1.321,0,0,1-.35-.429,1.2,1.2,0,0,1-.138-.617,1.416,1.416,0,0,1,.407-1.055,1.853,1.853,0,0,1,1.05-.5V85.249h.915v.957a4.986,4.986,0,0,1,.644.089c.249.063.433.116.534.152l.093.026-.221.849-.1-.035c-.165-.054-.34-.108-.515-.152a3.483,3.483,0,0,0-.755-.08,1.474,1.474,0,0,0-.756.179.545.545,0,0,0-.24.474.513.513,0,0,0,.074.286.532.532,0,0,0,.211.215,2.226,2.226,0,0,0,.359.187c.073.027.156.063.24.089s.156.054.24.09c.229.081.442.179.653.268a2.14,2.14,0,0,1,.553.34,1.465,1.465,0,0,1,.4.491,1.358,1.358,0,0,1,.147.68,1.413,1.413,0,0,1-.405,1.059Z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoDepositsPlayersAcc);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_deposits_players_acc.1721432a225b79a693d0a887241e85f0.svg";